<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['title', { rules: [{ required: true, message: '请输入名称' }] }]"
            name="title"
            placeholder="请输入名称"
          />
        </a-form-item>

        <a-form-item
          label="折扣比例"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          help="折扣比例0<=折扣<100的正整数，最终价格为原始价格*折扣比例%"
        >
          <a-input-number
            name="discount"
            v-decorator="[
              'discount',
              { rules: [{ required: true, message: '请输入名称' }], initialValue: 0 }
            ]"
          />
        </a-form-item>

        <a-form-item label="可用次数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            name="limit_count"
            v-decorator="[
              'limit_count',
              { rules: [{ required: true, message: '请输入名称' }], initialValue: 1 }
            ]"
          />
        </a-form-item>
        <a-form-item label="优惠码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['code', { rules: [{ required: true, message: '请输入优惠码' }] }]"
            name="code"
            placeholder="请输入优惠码"
          />
        </a-form-item>

        <a-form-item label="可使用课程" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-spin :spinning="coursesLoad">
            <a-select
              show-search
              allow-clear
              optionFilterProp="children"
              placeholder="请选择可使用课程"
              name="use_course"
              mode="multiple"
              v-decorator="['use_course']"
              @change="value => handleSelectChange(value, {name:'coursesList',isSearch: false})"
            >
              <a-select-option v-for="course in coursesList" :key="course.id" :disabled="course.disabled">
                {{ course.title }}
              </a-select-option>
            </a-select>
          </a-spin>
        </a-form-item>

        <a-form-item label="可使用证书" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-spin :spinning="crtsLoad">
            <a-select
              show-search
              allow-clear
              optionFilterProp="children"
              placeholder="请选择可使用证书"
              name="use_certificate"
              mode="multiple"
              v-decorator="['use_certificate']"
              @change="value => handleSelectChange(value, {name:'crtsList',isSearch: false})"
            >
              <a-select-option v-for="crt in crtsList" :key="crt.id" :disabled="crt.disabled">
                {{ crt.title }}
              </a-select-option>
            </a-select>
          </a-spin>
        </a-form-item>

        <a-form-item label="可使用套购" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-spin :spinning="packsLoad">
            <a-select
              show-search
              allow-clear
              optionFilterProp="children"
              placeholder="请选择可使用套购"
              name="use_arbitrage"
              mode="multiple"
              v-decorator="['use_arbitrage']"
              @change="value => handleSelectChange(value, {name:'packsList',isSearch: false})"
            >
              <a-select-option v-for="pack in packsList" :key="pack.id" :disabled="pack.disabled">
                {{ pack.title }}
              </a-select-option>
            </a-select>
          </a-spin>
        </a-form-item>
        <a-form-item label="开始时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            showTime
            :disabled-date="disabledStartDate"
            placeholder="请选择开始时间"
            style="width: 100%"
            format="YYYY-MM-DD HH:mm:ss"
            name="start_at"
            v-decorator="['start_at']"
          />
        </a-form-item>
        <a-form-item label="过期时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            showTime
            :disabled-date="disabledExpireDate"
            placeholder="请选择过期时间"
            style="width: 100%"
            name="end_at"
            format="YYYY-MM-DD HH:mm:ss"
            v-decorator="['end_at']"
          />
        </a-form-item>
        <a-form-item label="介绍" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea rows="4" name="remark" placeholder="请输入介绍" v-decorator="['remark']" />
        </a-form-item>

        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="是否在前端展示，默认展示">
          <a-switch
            checked-children="生效"
            un-checked-children="失效"
            name="state"
            v-decorator="[
              'state',
              {
                valuePropName: 'checked',
                initialValue: true
              }
            ]"
          />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button :loading="formLoading" @click="handleSubmit()" type="primary">提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { form, select } from '@/mixins'
import { GoBack } from '@/components'
import { handleSelectArr } from '@/utils/util'
const fields = ['title', 'discount', 'limit_count', 'code', 'use_course', 'use_certificate', 'use_arbitrage', 'start_at', 'end_at', 'state']
const apiList = {
    getInfo: '/coupons/',
    update: '/coupons/',
    crtsList: '/certificates/select',
    packsList: '/courses/packs/select',
    coursesList: '/courses/select'
}

export default {
    name: 'CouponEditForm',
    mixins: [form, select],
    components: {
        GoBack
    },
    data () {
        return {
            apiList,
            fields,
            coursesLoad: false,
            coursesList: [],
            crtsLoad: false,
            crtsList: [],
            packsLoad: false,
            packsList: []
        }
    },
    mounted () {
        const that = this
        if (that.$route.params.id) {
            that.getFormData(that.$route.params.id, function (values) {
                values.state = values.state === 1
                values.use_course = handleSelectArr(values.use_course)
                values.use_certificate = handleSelectArr(values.use_certificate)
                values.use_arbitrage = handleSelectArr(values.use_arbitrage)
            }) // 获取编辑信息
        }
        this.getSelectLists({
            url: apiList.coursesList,
            type: 'coursesList',
            load: 'coursesLoad',
            arr: [{ id: 'all', title: '通用' }]
        }) // 获取课程下拉列表
        this.getSelectLists({
            url: apiList.crtsList,
            type: 'crtsList',
            load: 'crtsLoad',
            arr: [{ id: 'all', title: '通用' }]
        }) // 获取证书下拉列表
        this.getSelectLists({
            url: apiList.packsList,
            type: 'packsList',
            load: 'packsLoad',
            arr: [{ id: 'all', title: '通用' }]
        }) // 获取套购下拉列表
    },
    methods: {
        /**
         * 禁止开始日期
         * 开始日期 > 结束日期
         * @startValue
         */
        disabledStartDate (startValue) {
            const endValue = this.form.getFieldValue('end_at')
            if (!endValue) {
                return false
            } else {
                return startValue.valueOf() > this.moment(endValue).valueOf()
            }
        },
        /**
         * 禁止过期日期
         * 开始日期 > 结束日期
         * @endValue
         */
        disabledExpireDate (endValue) {
            const startValue = this.form.getFieldValue('start_at')
            if (!startValue) {
                return false
            } else {
                return this.moment(startValue).valueOf() >= endValue.valueOf()
            }
        }
    }
}
</script>
